import React, {Component} from 'react';
import {authActions, Loader, modal, PageWrapper, utils} from '@mc/mc-legacy';
import {Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {Route, Switch, withRouter} from "react-router";
import AppWrapper from "./AppWrapper";
import {getAdminMenuItems} from "../const/AdminMenuItems";
import SpolecnostPage from "./administration/SpolecnostPage";
import SpolecnostCenikyPage from "./administration/SpolecnostCenikyPage";
import UzivatelPage from "./administration/UzivatelPage";
import {DropdownItem} from "reactstrap";
import {
    ADMIN_BASE_PATH,
    DOPRAVA_PATH,
    ORDER_BASE_PATH,
    ORDER_ROUTES,
    ORDERS_BASE_PATH,
    SPOLECNOSTI_PATH,
    UZIVATELE_PATH
} from "../const/routes";
import * as subjektActions from "../actions/subjektActions";
import * as localStorageUtils from "../utils/localStorageUtils";
import HomePage from "./HomePage";
import * as opravneniActions from "../actions/opravneniActions";
import * as uzivatelActions from "../actions/uzivatelActions";
import * as EnumRole from "../api/gen/cgo/EnumRole";
import ObjednavkyPage from "./ObjednavkyPage";
import ObjednavkaPage from "./ObjednavkaPage";
import ObjednavkaDokoncenaPage from "./customer/order/ObjednavkaDokoncenaPage";
import {SPOLECNOST_ID_KEY} from "../const/const";
import * as ciselnikActions from "../actions/ciselnikActions";
import * as objednavkaActions from "../actions/objednavkaActions";
import ZmenaHeslaForm from "../forms/ZmenaHeslaForm";
import OpravneniApi from "../api/gen/cgo/OpravneniApi";
import {toastr} from "react-redux-toastr";
import SpolecnostCenikPage from "./administration/SpolecnostCenikPage";
import DopravaTerminyPage from "./administration/DopravaTerminyPage";
import {withTranslation, WithTranslation} from "react-i18next";
import "./Layout.scss";
import CenikPage from "./administration/CenikPage";

const {storeFromArea} = utils;

class Layout extends Component<WithTranslation> {

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        this.fetchData(prevProps);
    }

    fetchData = (prevProps) => {
        const {isGuest, loggedInUser, uzivatelSpolecnostiList, spolecnostId} = this.props;
        if (!isGuest) {
            this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
            if (loggedInUser.fetched && !loggedInUser.isFetching) {
                this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUser.data.id));
                if (spolecnostId.fetched && !spolecnostId.isFetching) {
                    if (spolecnostId.data) {
                        this.props.dispatch(subjektActions.fetchAktivniSpolecnostDetailIfNeeded(spolecnostId.data));
                    } else if (uzivatelSpolecnostiList.fetched && uzivatelSpolecnostiList.rows.length > 0) {
                        // Pokud uživatel má nějakou společnost ale nemá žádnou aktivní, nastavíme mu první
                        localStorageUtils.save(loggedInUser.data.id, SPOLECNOST_ID_KEY, uzivatelSpolecnostiList.rows[0].id);
                        this.props.dispatch(uzivatelActions.invalidateSpolecnostId(loggedInUser.data.id));
                        this.props.dispatch(subjektActions.invalidateAktivniSpolecnostDetail(uzivatelSpolecnostiList.rows[0].id));
                    }
                }
                this.props.dispatch(uzivatelActions.fetchSpolecnostiPrihlasenyUzivatelIfNeeded(loggedInUser.data.id));
                // Pokud má uživatel nastavenou aktivní společnost ale už v ní není, smažeme jí z local storage
                if (prevProps && !prevProps.uzivatelSpolecnostiList.fetched && uzivatelSpolecnostiList.fetched) {
                    const aktivniSpolecnostId = localStorageUtils.load(loggedInUser.data.id, SPOLECNOST_ID_KEY);
                    if (aktivniSpolecnostId && !uzivatelSpolecnostiList.rows.find(s => s.id === aktivniSpolecnostId)) {
                        // console.debug(`Uživatel není ve společnosti ID ${aktivniSpolecnostId}, zneplatňuji data.`);
                        localStorageUtils.clear(loggedInUser.data.id, SPOLECNOST_ID_KEY);
                        this.props.dispatch(subjektActions.invalidateAktivniSpolecnostDetail(aktivniSpolecnostId));
                        this.invalidateUzivatelSpolecnostData();
                    }
                }
            }
        }
    };

    // Zneplatnění dat která se pro uživatele načítají v závislosti na jeho aktivní společnosti
    invalidateUzivatelSpolecnostData = () => {
        const {loggedInUser} = this.props;
        this.props.dispatch(uzivatelActions.invalidateSpolecnostId(loggedInUser.data.id));
        this.props.dispatch(ciselnikActions.invalidatePobockyUzivatel());
        this.props.dispatch(objednavkaActions.invalidateObjednavkyCountStats());
        this.props.dispatch(objednavkaActions.invalidateObjednavkyPrehled());
        this.props.dispatch(objednavkaActions.invalidateObjednavky());
        this.props.dispatch(objednavkaActions.invalidateDataZakazka());
        this.props.dispatch(objednavkaActions.invalidateDataZakaznik());
        this.props.dispatch(objednavkaActions.invalidateDataDoprava());
        this.props.dispatch(objednavkaActions.invalidateDataPlatba());
        this.props.dispatch(subjektActions.invalidateAdresySpolecnost());
        localStorageUtils.clearAllOrderData(loggedInUser.data.id);
    };

    handleZmenitSpolecnost = (spolecnost) => {
        const {loggedInUser} = this.props;
        if (spolecnost.id) {
            this.props.dispatch(subjektActions.invalidateAktivniSpolecnostDetail(spolecnost.id));
            localStorageUtils.save(loggedInUser.data.id, SPOLECNOST_ID_KEY, spolecnost.id);
        } else {
            localStorageUtils.clear(loggedInUser.data.id, SPOLECNOST_ID_KEY);
        }
        this.invalidateUzivatelSpolecnostData();
    };

    redirectToAdministrace = (menuItems) => {
        this.props.history.push(menuItems[0].path);
    };

    handlePasswordChange = () => {
        const {loggedInUser, t} = this.props;
        this.props.dispatch(modal.ModalActions.show(
            ZmenaHeslaForm,
            {
                onSubmit: (data) => {
                    OpravneniApi.changePassword(loggedInUser.data.id, data.oldPassword, data.password).then(() => {
                        toastr.success(t('password_changed'));
                    });
                },
                onSubmitSuccess: (result, dispatch) => {
                    dispatch(modal.ModalActions.hide());
                },
                onClose: () => this.props.dispatch(modal.ModalActions.hide()),
            },
            t('password_change'),
            {size: "sm"}
        ));
    };

    render() {
        const {isFetched, uzivatelSpolecnostiList, loggedInUser, spolecnostDetail, t} = this.props;

        if (!isFetched) {
            return <Loader />
        }

        let adminMenuItems = [];
        const userMenuAddons = [];
        let nazevSpolecnost = null;
        if (loggedInUser.fetched) {

            // Získání položek admin menu na základě role
            adminMenuItems = getAdminMenuItems(loggedInUser.data, t);

            if (__DEV__) {
                userMenuAddons.push(<DropdownItem key="role" header>{t('simulate_role_client')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="uzivatel" onClick={() => localStorageUtils.save(loggedInUser.data.id, "DEV_ROLE", EnumRole.UZIVATEL)}>{t('user.one')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="operator" onClick={() => localStorageUtils.save(loggedInUser.data.id, "DEV_ROLE", EnumRole.OPERATOR)}>{t('admin.operator')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="spravce" onClick={() => localStorageUtils.save(loggedInUser.data.id, "DEV_ROLE", EnumRole.SPRAVSPOL)}>{t('company_manager')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="admin" onClick={() => localStorageUtils.save(loggedInUser.data.id, "DEV_ROLE", EnumRole.ADMIN)}>{t('admin.administrator')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="zadna" onClick={() => localStorageUtils.clear(loggedInUser.data.id, "DEV_ROLE")}>{t('default_brackets')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="divider1" divider/>);
                userMenuAddons.push(<DropdownItem key="ladeni" header>{t('tuning')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="clearData" onClick={() => localStorageUtils.clearAllOrderData(loggedInUser.data.id)}>{t('order.delete_in_process')}</DropdownItem>);
                userMenuAddons.push(<DropdownItem key="divider2" divider/>);
            }
            userMenuAddons.push(<DropdownItem key="zmenitHeslo" onClick={this.handlePasswordChange}>{t('change_password')}</DropdownItem>);

            const canZmenitSpolecnost = uzivatelSpolecnostiList.fetched && uzivatelSpolecnostiList.rows.length > 1;
            const canAccessAdministrace = loggedInUser.data.role === EnumRole.ADMIN || loggedInUser.data.role === EnumRole.SPRAVSPOL;

            if (canZmenitSpolecnost) {
                userMenuAddons.push(<DropdownItem key="spolecnosti" header>{t('companies')}</DropdownItem>);
                uzivatelSpolecnostiList.rows.forEach(spolecnost => {
                    userMenuAddons.push(<DropdownItem key={spolecnost.id} onClick={this.handleZmenitSpolecnost.bind(this, spolecnost)}>{spolecnost.nazevSpolecnost}</DropdownItem>);
                });
                userMenuAddons.push(<DropdownItem divider/>);
            }

            if (canAccessAdministrace && adminMenuItems.length > 0) {
                userMenuAddons.push(<DropdownItem key="administrace" onClick={this.redirectToAdministrace.bind(this, adminMenuItems)}>{t('admin.administration')}</DropdownItem>);
            }

            // Pokud má uživatel aktivní společnost, předáme do wrapperu její název
            if (spolecnostDetail.fetched && !spolecnostDetail.isFetching && spolecnostDetail.data) {
                nazevSpolecnost = spolecnostDetail.data.nazevSpolecnost;
            }
        }

        const canAccessAdministrace = loggedInUser.fetched && (loggedInUser.data.role === EnumRole.ADMIN || loggedInUser.data.role === EnumRole.SPRAVSPOL);
        return <AppWrapper
            appCode="cgo"
            homeLink="/"
            nazevSpolecnost={nazevSpolecnost}
            logoUrl={`${serverContextPath}/api/cgo/ciselnik/firma/logo`}
            userMenuAddons={userMenuAddons}
            backButtonIcon={this.props.location.pathname !== "/"}
            goBack={this.props.location.pathname !== "/"}
            >
            <PageWrapper>
                <modal.ModalDialog/>
                <Switch>
                    {/* Pozor na pořadí! Konkrétnější musejí být napřed */}

                    {/* Kroky objednávky */}
                    {ORDER_ROUTES.map((route, index) => <Route key={index} path={route.path} component={route.component}/>)}
                    {/* Objednávky, detail objednávky */}
                    <Route path={`/${ORDER_BASE_PATH}/:id/potvrzeni`} component={ObjednavkaDokoncenaPage}/>
                    <Route path={`/${ORDER_BASE_PATH}/:id`} component={ObjednavkaPage}/>
                    <Route path={`/${ORDERS_BASE_PATH}`} component={ObjednavkyPage}/>
                    {/* Administrace */}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/${UZIVATELE_PATH}/:id`} component={UzivatelPage}/>}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/:id/ceniky/:idCenik`} component={SpolecnostCenikPage}/>}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/:id/ceniky`} component={SpolecnostCenikyPage}/>}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/ceniky/:idCenik`} component={CenikPage}/>}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/${SPOLECNOSTI_PATH}/:id`} component={SpolecnostPage}/>}
                    {canAccessAdministrace && <Route path={`/${ADMIN_BASE_PATH}/${DOPRAVA_PATH}/:id/terminy`} component={DopravaTerminyPage}/>}
                    {adminMenuItems.map(menuItem => <Route key={menuItem.key} path={menuItem.path} component={menuItem.component}/>)}
                    {canAccessAdministrace && adminMenuItems.length > 0 && <Redirect from={`/${ADMIN_BASE_PATH}`} to={adminMenuItems[0].path}/>}

                    {ORDER_ROUTES.length > 0 && <Redirect from={`/${ORDER_BASE_PATH}`} to={ORDER_ROUTES[0].path}/>}
                    <Route exact path="/" component={HomePage}/>
                    <Route component={() => <Redirect to={"/"} />} />
                </Switch>
            </PageWrapper>
        </AppWrapper>
    }
}


export default withRouter(connect(state => {
    const authInfo = storeFromArea(state, authActions.AUTH_INFO_AREA);
    return {
        isFetched: authInfo.fetched,
        isGuest: !authInfo.fetched || !authInfo.data.auth,
        loggedInUser: storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        uzivatelSpolecnostiList: storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA),
        spolecnostId: storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        spolecnostDetail: storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA),
    }
})(withTranslation()(Layout)))
